
import { ref, inject, computed, onBeforeMount, onMounted } from "vue";

import BasicCard from "@/views/pages/questionnaire/components/BasicCard.vue";
import { NSpin } from "naive-ui";

import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { Actions, Mutations } from "@/store/enums/QuestionnaireStoreEnums";
import { useGtm } from "@gtm-support/vue-gtm";
import { QUESTIONNAIRE_TYPES } from "@/views/pages/questionnaire/constants/constants";


export default {
  name: "QuestionnaireLanding",
  components: { BasicCard, NSpin },

  setup() {
    const gtm = useGtm();
    const router = useRouter();
    const i18n = useI18n();
    const isMobile = inject("isMobile");
    const store = useStore();
    const isLoading = ref(false);
    const { t } = i18n;
    const questionnairePersonaTypes = ref();

    onMounted(async () => {
      await store.dispatch(Actions.GET_PERSONA_TYPES);

      if (personaTypes.value && personaTypes.value.length) {
        questionnairePersonaTypes.value = questionnaireTypeList.map((type) => {
          return {
            ...type,
            title: personaTypes.value.find((pType) => pType.id === type.id)?.persona_name,
          };
        });
      }

      const getLinkQuery = router.currentRoute.value.query;

      if (getLinkQuery && getLinkQuery.partner) {

        await router.replace({ query: undefined });
        
          localStorage.setItem("partner", getLinkQuery.partner as string);
        

      } else if (getLinkQuery && getLinkQuery.questionnaire_token) {

        await router.replace({ query: undefined });

          await store.dispatch(
            Actions.CHECK_QUESTIONNAIRE_TOKEN,
            getLinkQuery.questionnaire_token
          );

      }



      store.commit(Mutations.SET_SIDE_ANIMATION_COMPLETION_STATE, false);

      gtm?.trackEvent({
        event: "questionnaire_persona_page_view",
        event_name: "questionnaire_persona_page_view",
        category: "Custom Events",
        label: "Persona Page",
      });
    });

    const questionnaireRouteMapper = ref<any>({
      [QUESTIONNAIRE_TYPES.Patient]: "patient-questionnaire",
      [QUESTIONNAIRE_TYPES.Caregiver]: "caregiver-questionnaire",
      [QUESTIONNAIRE_TYPES.Physician]: "physician-questionnaire",
      [QUESTIONNAIRE_TYPES.Other]: "other-questionnaire",
    });

    const questionnaireTypeList = [
      {
        id: QUESTIONNAIRE_TYPES.Patient,
        title: t("Patient"),
        description: t("Looking for myself"),
        imageSrc: "/media/img/questionnaire_persona/persona_patient.png",
      },
      {
        id: QUESTIONNAIRE_TYPES.Caregiver,
        title: t("Caregiver"),
        description: t("Looking for a loved one"),
        imageSrc: "/media/img/questionnaire_persona/persona_caregiver.png",
      },
      {
        id: QUESTIONNAIRE_TYPES.Physician,
        title: t("Physician"),
        description: t("Find trials for your patient"),
        imageSrc: "/media/img/questionnaire_persona/persona_physician.png",
      },
      {
        id: QUESTIONNAIRE_TYPES.Other,
        title: t("Other"),
        description: t("Looking for information"),
        imageSrc: "/media/img/questionnaire_persona/persona_other.png",
      },
    ];

    async function handleQuestionnaireSelect(personaId) {
      gtm?.trackEvent({
        event: "questionnaire_persona_click",
        event_name: "questionnaire_persona_click",
        category: "Custom Events",
        label: "Persona Page",
        gtm: {
          personaType:
            questionnaireTypeList.find((persona) => persona.id === personaId)
              ?.title || personaId,
        },
      });

      if (personaId !== store.getters.personaId) {
        store.commit(Mutations.RESET_QUESTIONNAIRE_ANSWERS);
      }

      isLoading.value = true;

      try {
        await store.dispatch(Actions.POST_SELECTED_PERSONA, {
          persona_id: personaId,
          ...{ questionnaire_id: questionnaireIdTemp.value || undefined },
        });

        if (questionnaireId.value) {
          await router.push({
            name: questionnaireRouteMapper.value[personaId],
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        isLoading.value = false;
      }
    }

    const personaTypes = computed(() => {
      return store.getters.personaTypes;
    });

    const questionnaireId = computed(() => {
      return store.getters.questionnaireId;
    });

    const questionnaireIdTemp = computed(() => {
      return store.getters.questionnaireIdTemp;
    });



    return {
      isMobile,
      isLoading,
      questionnaireTypeList,
      handleQuestionnaireSelect,
    };
  },
};
